var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendors({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 10.9062V16.25C4.25 16.4158 4.31585 16.5747 4.43306 16.6919C4.55027 16.8092 4.70924 16.875 4.875 16.875H16.125C16.2908 16.875 16.4497 16.8092 16.5669 16.6919C16.6842 16.5747 16.75 16.4158 16.75 16.25V10.9062",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71875 3.125H16.2812C16.4168 3.12612 16.5485 3.17075 16.6568 3.25233C16.7651 3.33391 16.8443 3.44812 16.8828 3.57812L18 7.5H3L4.11719 3.57812C4.15568 3.44812 4.23492 3.33391 4.34322 3.25233C4.45152 3.17075 4.58317 3.12612 4.71875 3.125V3.125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5V8.75C8 9.41304 7.73661 10.0489 7.26777 10.5178C6.79893 10.9866 6.16304 11.25 5.5 11.25C4.83696 11.25 4.20107 10.9866 3.73223 10.5178C3.26339 10.0489 3 9.41304 3 8.75V7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5V8.75C13 9.41304 12.7366 10.0489 12.2678 10.5178C11.7989 10.9866 11.163 11.25 10.5 11.25C9.83696 11.25 9.20107 10.9866 8.73223 10.5178C8.26339 10.0489 8 9.41304 8 8.75V7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5V8.75C18 9.41304 17.7366 10.0489 17.2678 10.5178C16.7989 10.9866 16.163 11.25 15.5 11.25C14.837 11.25 14.2011 10.9866 13.7322 10.5178C13.2634 10.0489 13 9.41304 13 8.75V7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendors);
export default __webpack_public_path__ + "static/media/Vendors.c254fa16188b78248b461b6ae25686bf.svg";
export { ForwardRef as ReactComponent };